/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { twMerge } from 'tailwind-merge';
const DEFAULT_OPTIONS = ['Last 7 Days', 'Last 1 Month', 'Last 1 Year'];

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
})
export class DropdownComponent implements OnInit, OnChanges {
    @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;

    @Input() title?: string;
    @Input() options?: any[];
    @Input() value?: any;
    @Input() btnClassProps?: string;
    @Input() dropdownClassProps?: string;
    @Input() default: number = 0;
    @Input() selectedValue?: any;
    @Input() dropdownStyle = DropdownStyle.Default;

    @Output() callback = new EventEmitter();
    @Output() valueChange = new EventEmitter();

    DropdownStyle = DropdownStyle;

    currentOptions: any[] = [];
    selected: any;
    selectedDropdownName = '';
    btnClass = '';
    dropdownClass = '';
    isOpen = false;

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (this.dropdownMenu) {
            if (!this.dropdownMenu.nativeElement.contains(event.target)) {
                this.isOpen = false;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedValue']) {
            this.setSelectedOption();
        }
    }

    ngOnInit(): void {
        this.currentOptions = this.options?.length ? this.options : DEFAULT_OPTIONS;
        this.selected = this.currentOptions[this.default];
        this.selectedDropdownName = this.selected.name;
        this.btnClass = twMerge('dropdown-panel dropdown-btn', this.btnClassProps);
        this.dropdownClass = twMerge(
            'absolute dropdown flex-col z-20 top-full duration-300 origin-top min-w-full shadow-[0px_6px_30px_0px_rgba(0,0,0,0.08)] max-h-40 overflow-y-auto bg-n0 p-1 rounded-md',
            this.dropdownClassProps,
        );
        if (this.selectedValue) {
            this.setSelectedOption();
        }
    }

    selectOption(option: any): void {
        if (!this.selectedValue) {
            this.selected = option;
        }

        this.isOpen = false;

        this.valueChange.emit(option.value);
        this.callback.emit(option.value);
    }

    toggleOpen(event: MouseEvent): void {
        const allDropdowns = document.querySelectorAll('.dropdown');

        allDropdowns.forEach((dropdown) => {
            if (dropdown !== event.target) {
                dropdown.classList.remove('show');
                dropdown.classList.add('hide');
            }
        });

        this.isOpen = !this.isOpen;
    }

    private setSelectedOption(): void {
        this.selected = this.options?.find((item: any) => item.value === this.selectedValue);

        this.selectedDropdownName = this.selected?.name;
    }
}

export enum DropdownStyle {
    Default = 1,
    ProgramAvailableLanguage = 2,
}
